const datePickerLocale = {
  selectDate: "Select Date",
  now: "Now",
  clear: "Clear",
  selectDateRange: "Select Date Range",
  startTime: "Start time",
  endTime: "End time",
  timeLabel: "{{hour}} hours {{minute}} minutes {{second}} seconds",
  noTimeSelected: "No time selected",
  timePanelAriaLabel: ["hour", "minute", "second"],
  rangeTime: "{{startTime}} - {{endTime}}"
};
export {
  datePickerLocale
};
//# sourceMappingURL=en_US.js.map
